module.exports = __webpack_public_path__ + "static/img/Qr-code.4421c058.png";